export default __webpack_public_path__ + "static/media/icon-arrow-left.a6d9574e.svg";